export default __webpack_public_path__ + "static/media/survey_flow.c98e5054.png";